/**
 * The Helper module
 */
import { requestData } from "./utils";

export default class Helper {
  // constructor() {}
  getEnvironment() {
    return requestData("GET", "/environment");
  }
  getAllGateways() {
    return requestData("GET", `/get_all_gateways`);
  }
  getValidTimezoneValues() {
    return requestData("GET", `/sys/all_valid_timezone_values`);
  }
  getValidContactTypeValues() {
    return requestData("GET", `/sys/all_valid_contact_type_values`);
  }
  getValidCountryCodeValues() {
    return requestData("GET", `/sys/all_valid_country_code_values`);
  }
  getSupportedCurrencyCodes() {
    return requestData("GET", `/sys/all_supported_currency_code_values`);
  }
  getSupportedTaxRegions() {
    return requestData("GET", `/sys/all_supported_tax_region_values`);
  }
  getValidUserRoleValues() {
    return requestData("GET", `/permissions/all_valid_user_role_values`);
  }
  getValidAdminUserRoleValues() {
    return requestData("GET", `/permissions/all_valid_admin_user_role_values`);
  }
  getValidPasswordPolicy() {
    return requestData("GET", `/sys/password_policy`);
  }
  getValidProductValues() {
    return requestData("GET", `/sys/all_valid_product_values`);
  }
  getValidSMPPEncodings() {
    return requestData("GET", `/sys/all_valid_smpp_encodings`);
  }
  getValidAPIChannels() {
    return requestData("GET", `/sys/all_valid_api_channels`);
  }
  getValidAuthSignatureMethods() {
    return requestData("GET", `/sys/all_valid_auth_signature_methods`);
  }
  getValidCredentialTypes() {
    return requestData("GET", `/all_valid_credential_types`);
  }
  getValidNetworks(selectedCountry = "") {
    const endpoint = selectedCountry !== "all"
      ? `/valid_networks/${selectedCountry}`
      : `/all_valid_networks`;
    return requestData("GET", endpoint);
  }
  getAllLanguages() {
    return requestData("GET", `/sys/all_supported_language_values`);
  }
  getAllUserStatuses() {
    return requestData("GET", `/sys/all_supported_user_status_values`);
  }
  getAllAdminUserStatuses() {
    return requestData("GET", `/sys/all_supported_admin_user_status_values`);
  }
  getAllEnterpriseAccountTypes() {
    return requestData("GET", `/sys/all_valid_enterprise_account_types`);
  }
  getSmsConfig() {
    return requestData("GET", `/sms/smsConfig`);
  }
  getAllCountries() {
    return requestData("GET", `/sys/all_supported_country_code_values`)
  }
  getAllHandlers() {
    return requestData("GET", `/get_all_handlers`)
  }
}
